<template>
  <!-- <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    submit-text="Confirm"
    @submit="submit"
    @close-modal="closeModal"
  > -->
  <app-modal
    :modal-id="modalId"
    :modal-size="modalSize"
    :modal-alignment="modalAlignment"
    :modal-body-class="'w-full max-w-full wizard-steps'"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">
        {{ modalTitle }}
      </h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
        @click.prevent="closeModal"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        @submit.prevent="submit"
        :data-url="
          selectedUrl
            ? `transaction/placement/packageConfirm/${inputs.id}`
            : `transaction/placement/packageConfirm`
        "
      >
        
        <div v-if="productRecommendedList.length && productRecommendedList[activeTab]">
          <div class="mb-3">
            
            <ul class="nav nav-pills mb-4" id="pills-tab">
              <li
                class="nav-item"
                v-for="(tab, index) in productRecommendedList"
                :key="index"
              >
                <a
                  class="nav-link"
                  :class="{ active: index === activeTab }"
                  href="javascript:void(0)"
                  @click.prevent="activeTab = index"
                >
                
                  <div
                    class="text-capitalize"
                    :class="[index === 0 ? 'tab-step-init' : 'tab-step']"
                  >
                    Invoice {{ index + 1 }}
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div
              v-for="(pkg, index) in productRecommendedList[activeTab].packages"
              :key="index"
              class="form-group row align-items-center mt-2"
            >
              <label
                class="col-md-3 mb-0"
                style="font-size: 13px; font-weight: 600"
                :for="`pkg_${index}`"
                >Package {{ index + 1 }}</label
              >
              <div class="col-sm-9">
                <input
                  v-if="productRecommendedList[activeTab].packages.length > 1"
                  type="checkbox"
                  :id="`pkg_${index}`"
                  v-model="pkg.selected"
                />
              </div>
              <label for="inputs_product" class="col-sm-3 mb-0">
                Product Name
              </label>
              <div class="col-sm-9">
                <div class="input-span">{{ pkg.product_name }}</div>
              </div>
              <label for="inputs_package" class="col-sm-3 mb-0">
                Packages Name
              </label>
              <div class="col-sm-9">
                <div class="input-span">{{ pkg.package_name }}</div>
              </div>
              <label for="inputs_due_date" class="col-sm-3 mb-0">
                Due Date
              </label>
              <div class="col-sm-9">
                <div class="input-span">{{ pkg.due_date }}</div>
              </div>
            </div>
            <div class="form-group row align-items-center mt-3">
              <label class="col-sm-3 mb-0">Notes</label>
              <div class="col-sm-9">
                <app-input
                  type="textarea"
                  v-model="productRecommendedList[activeTab].notes"
                  placeholder="Notes"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cancel
      </button>
      &nbsp;
      <button type="button" class="btn btn-primary" @click="submit">
        Confirm
      </button>
    </template>
  </app-modal>
</template>

<script>
import { PlacementBookingFormMixin } from "./PlacementBookingFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../Auth/Mixins/UserMixin";

export default {
  name: "PlacementBookingApproveTableForm",
  mixins: [PlacementBookingFormMixin, ModalMixin, UserMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      preloader: false,
      productRecommendedList: [],
      activeTab: 0,
      inputs: {
        id: null,
        packages: [],
        clc_id_number: this.value.clc_id_number,
        notes: "",
      },
      confirmPackage: true,
      modalId: this.formId,
      modalTitle: "Package Confirmation",
      modalSize: "default",
      modalAlignment: "top",
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = "Package Confirmation";
      this.preloader = true;
    }
  },
  // async mounted() {
  //   try {
  //     const res = await axios.get("/master/academic-calendar");
  //     var academicCalendarOptions = res.data.data || [];

  //     this.setDefaultSemester(academicCalendarOptions);
  //   } catch (err) {
  //     console.error("Gagal fetch academic calendar", err);
  //   }
  // },
  methods: {
    // setDefaultSemester(list) {
    //   const today = new Date();
    //   today.setHours(0,0,0,0);

    //   const current = list.find((item) => {
    //     const start = new Date(item.date_start);
    //     const end = new Date(item.date_end);

    //     start.setHours(0,0,0,0);
    //     end.setHours(23,59,59,999);

    //     return today >= start && today <= end;
    //   });

    //   if (current) {
    //     this.input_academic_calendar_id = current;
    //     this.inputs.academic_calendar_id = current.id;
    //   }
    // },

    submit() {
      const payload = [];

      for (let i = 0; i < this.productRecommendedList.length; i++) {
        const tab = this.productRecommendedList[i];

        // cek apakah tab ini butuh selection
        const needSelection = tab.packages.length > 1;

        let selectedPackages = [];

        if (needSelection) {
          selectedPackages = tab.packages.filter(pkg => pkg.selected);

          if (selectedPackages.length === 0) {
            Swal.fire({
              title: "Warning",
              text: `Please select at least one package in Invoice ${i + 1}`,
              icon: "warning",
            });
            return;
          }
        } else {
          // auto select kalau hanya 1 package
          selectedPackages = tab.packages;
        }

        payload.push({
          packages: selectedPackages.map(pkg => ({
            product_id: Number(pkg.product_id),
            package_id: Number(pkg.package_id),
            due_date: pkg.due_date,
            academic_calendar_id: Number(pkg.academic_calendar_id),
          })),
          notes: tab.notes || "",
        });
      }

      this.save({
        id: this.inputs.id,
        clc_id_number: this.inputs.clc_id_number,
        packages: payload
      });
    },
    // setAcademicCalendarId(data) {
    //   this.inputs.academic_calendar_id = data.id;
    //   this.input_academic_calendar_id = data;
    // },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      this.inputs = {};
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;

      // this.inputs.due_date = response.data.recomend_class[0]?.due_date;
      this.inputs.invoice_type = response.data.recomend_class[0]?.invoice_type;
      this.inputs.notes = "";

      this.productRecommendedList = response.data.recomend_class.map(
        (semester, index) => {
          return {
            semester_index: index,
            notes: "",
            packages: semester.map((pkg) => ({
              product_id: pkg.product?.id || null,
              package_id: pkg.package?.id || null,
              product_name: pkg.product?.name || null,
              package_name: pkg.package?.package_name || null,
              due_date: pkg.due_date || null,
              academic_calendar_id: pkg.academic_calendar_id || null,
              selected: false,
            })),
          };
        }
      );

      if (this.productRecommendedList.length === 1) {
        this.productRecommendedList[0].selected = true;
      }

      this.preloader = false;
    },
  },
};
</script>

<style scoped>
  .input-span {
    background: #eee;
    height: 46px;
    border: 1px solid #4b6c9d;
    border-radius: 6px !important;
    padding: 12px;
    margin-bottom: 5px !important;
  }
  .horizontal-tab .card .nav a.active {
    border-bottom: 0 !important;
  }
</style>
